package dev.wyns.ventrova.ui.cupertino

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import dev.wyns.ventrova.AppDependencies
import dev.wyns.ventrova.app.AppEnvironment
import dev.wyns.ventrova.app.AppUiState
import dev.wyns.ventrova.app.AppViewModel
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.launch

/** Heights of the floating places panel on the map. */
enum class PanelDetent { Peek, Half, Full }

/**
 * State shared by the chrome of the iOS design (native UIKit on iOS, a Compose imitation on web)
 * and its Compose content. The chrome observes [viewModel]; the content calls back through the
 * `on…` handlers the chrome installs.
 */
class CupertinoModel(val dependencies: AppDependencies, val style: CupertinoStyle) {
    val viewModel = AppViewModel(dependencies.placeRepository, dependencies.keyValueStore, dependencies.suggestionService)

    /** Set by the Compose map while it is on screen; owns the map camera and location state. */
    var environment: AppEnvironment? by mutableStateOf(null)

    val detent = MutableStateFlow(PanelDetent.Peek)

    val scope = MainScope()

    /** Installed by the root controller. */
    var onOpenFilters: () -> Unit = {}
    var onCloseFilters: () -> Unit = {}
    var onOpenSuggest: () -> Unit = {}
    var onCloseSuggest: () -> Unit = {}

    /** Runs [block] on the main thread whenever the selected part of the state changes. */
    fun <T> observe(selector: (AppUiState) -> T, block: (T) -> Unit) {
        scope.launch {
            viewModel.state.map(selector).distinctUntilChanged().collect(block)
        }
    }

    fun cycleDetent() {
        detent.value = PanelDetent.entries[(detent.value.ordinal + 1) % PanelDetent.entries.size]
    }
}
